import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import avatar from '../../images/user_avatar.png';
import {withRouter} from 'react-router';
import ArticleTeaser from './article_teaser'
import DATA from '../../data/article_data'
import {
    Alignment,
    Button,
    Classes,
    H5,
    Navbar,
    NavbarDivider,
    NavbarGroup,
    NavbarHeading,
    Switch,
} from "@blueprintjs/core";


class ArticleList extends Component {

    constructor(props){
        super(props);
        //console.log(props,this.state)
        this.state = { 
            blog_data : DATA.blog_data,
            articles: DATA.articles,
        }
    };

    items = DATA.articles.map(item => {
        return <ArticleTeaser id={item.id} name={item.title} teaser={item.teaser} source={item.source} link={item.link} image={item.image}/>;
    });

  render() {
    return (
        <div className="blogs_list blog_section">
        <h2>Wellness Matrix Group Articles</h2>
        <ul className="flex-grid-thirds">
            {this.items}
        </ul>
        </div>
    );
  }
}

export default withRouter(ArticleList);